import React from 'react'
import styles from './description.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Description = ({ classes, children, className }) => (
  <div className={classNames(classes.container, className)}>
    <span className={classes.description}>{children}</span>
  </div>
)

export default injectSheet(styles)(Description)
